module.exports = "<app-nav-bar></app-nav-bar>\n\n\n\n\n<app-footer></app-footer>\n"